module.exports = __webpack_public_path__ + "img/p5.e02ca26a.png";